import RelationBase from "./RelationBase";
import BaseModel from "./BaseModel";
import { isDevelopmentEnvironment } from "../estada-config";

export default class RelationOneToOne<ToClass extends BaseModel> extends RelationBase {
    get toClassNames(): Array<string> {
        return [];
    }

    protected from: BaseModel;
    protected fromClassName: string;

    protected backReferencePropertyName: string;

    //////////////////////////////////////////////////////////////
    protected _to: ToClass | undefined;
    protected _toId: string | undefined;

    protected set_to(value: ToClass | undefined) {
        if (value && !this.toClassNames.includes(value.className)) {
            console.error(
                `RelationOneToOne: Object with id '${value.id}' is not a valid target. Expected one of [${this.toClassNames.join(", ")}], got '${value.className}'`,
            );
            this._to = undefined;
            this._toId = undefined;
        } else {
            this._to = value;
            this._toId = undefined;
        }
    }

    protected set_backreference() {
        if (this.from.className != this.fromClassName) {
            console.error(
                `RelationOneToOne: Object with id '${this.from.id}' is not a valid source. Expected ${this.fromClassName}, got '${this.from.className}'`,
            );
        } else {
            if (this._to) {
                (this._to as any)[this.backReferencePropertyName] = this.from;
                this._to.raiseOnChangeUI(this.backReferencePropertyName);
            }
        }
    }

    protected remove_backreference() {
        if (this._to) {
            (this._to as any)[this.backReferencePropertyName] = null;
            this._to.raiseOnChangeUI(this.backReferencePropertyName);
        }
    }


    public get to(): ToClass | undefined {
        if (this._to == undefined && this._toId) {
            this.set_to(state.objectRegistry.getObject<ToClass>(this._toId));
        }

        return this._to;
    }

    public set to(newValue: ToClass | undefined) {
        if (isDevelopmentEnvironment() && newValue) {
            if (!((this.backReferencePropertyName in newValue) as any)) {
                console.error(
                    `RelationOneToOne: backReferencePropertyName '${this.backReferencePropertyName}' not found in object of class '${newValue.className}'`,
                );
            }
        }

        //
        // clear old backReference
        //
        this.remove_backreference();

        //
        // set new values
        //

        this.set_to(newValue);
        this.set_backreference();
    }

    initRelation() {
        if (!this._to && this._toId) {
            this.set_to(state.objectRegistry.getObject<ToClass>(this._toId));
        }
        this.set_backreference();
    }

    //////////////////////////////////////////////////////////////

    public get toId(): string | undefined {
        if (this._toId) {
            return this._toId;
        }
        return this._to?.id;
    }

    public set toId(newValue: string | undefined) {
        this._toId = newValue;
        this._to = undefined;
    }

    ///////////////////////////////////////////////////////////////

    constructor(props: { from: BaseModel; fromClassName: string; backReferencePropertyName: string }) {
        super();

        if (props.from?.className != props.fromClassName) {
            const s = `RelationOneToOne: Constructor: from is invalid. Expected ${props.fromClassName}, got '${props.from?.className}'`;
            console.error(s);
            throw new Error(s);
        }

        this.from = props.from;
        this.fromClassName = props.fromClassName;
        this.backReferencePropertyName = props.backReferencePropertyName;
    }
}
